// extracted by mini-css-extract-plugin
module.exports = {"name":"productloadinglist_name__3im5D","animated-background":"productloadinglist_animated-background__u1ZPl","placeHolderShimmer":"productloadinglist_placeHolderShimmer__1lJiT"};